import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pagerduty_colored",
  "use": "pagerduty_colored-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"pagerduty_colored\"><path fill=\"#04AC38\" d=\"M17.668 2H6.332A4.33 4.33 0 0 0 2 6.332v11.336A4.33 4.33 0 0 0 6.332 22h11.336A4.33 4.33 0 0 0 22 17.668V6.332A4.33 4.33 0 0 0 17.668 2\" /><path fill=\"#fff\" d=\"M13.09 5.333H7.897v8.077h5.192a4.038 4.038 0 0 0 .001-8.077m-.513 6.41H9.821V7h2.756a2.372 2.372 0 0 1 0 4.744m-4.68 6.924H9.82v-3.59H7.897z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol